import i18next from 'i18next';
import en from './navigation-i18n/en';
import AuthRoles from '@/app/auth/authRoles';
import type { RoleName } from 'app/shared-components/Types/Role';

i18next.addResourceBundle('en', 'navigation', en);

export interface NavigationConfig {
  id: string;
  title: string;
  translate: string;
  type: string;
  icon: string;
  url: string;
  auth: readonly RoleName[];
  end?: boolean;
}

const navigationConfig: NavigationConfig[] = [
  {
    id: 'clients-component',
    title: 'Clients',
    translate: 'CLIENTS',
    type: 'item',
    icon: 'material-outline:person',
    url: 'clients',
    end: true,
    auth: AuthRoles.Sales,
  },
  {
    id: 'orders-component',
    title: 'Orders',
    translate: 'ORDERS',
    type: 'item',
    icon: 'material-outline:request_quote',
    url: 'orders',
    end: true,
    auth: AuthRoles.Orders,
  },
  {
    id: 'sales-component',
    title: 'Sales Pipeline',
    translate: 'Sales',
    type: 'item',
    icon: 'material-outline:event_available',
    url: 'sales',
    auth: AuthRoles.Sales,
  },
  {
    id: 'leads-component',
    title: 'Leads',
    translate: 'Leads',
    type: 'item',
    icon: 'material-outline:search',
    url: 'leads',
    auth: AuthRoles.Sales,
  },
  {
    id: 'processing-component',
    title: 'Processing',
    translate: 'Processing',
    type: 'item',
    icon: 'material-outline:support_agent',
    url: 'processing',
    auth: AuthRoles.Sales,
  },
  {
    id: 'provider-component',
    title: 'Providers',
    translate: 'Providers',
    type: 'item',
    icon: 'material-outline:power',
    url: 'providers',
    end: true,
    auth: AuthRoles.ServiceConfig,
  },
  {
    id: 'companies-component',
    title: 'Companies',
    translate: 'Companies',
    type: 'item',
    icon: 'material-outline:business',
    url: 'companies',
    end: true,
    auth: AuthRoles.Companies,
  },
  {
    id: 'subscriptions-component',
    title: 'Subscriptions',
    translate: 'Subscriptions',
    type: 'item',
    icon: 'material-outline:electrical_services',
    url: 'subscriptions',
    end: true,
    auth: AuthRoles.Subscriptions,
  },
  {
    id: 'goals-component',
    title: 'Goals',
    translate: 'Goals',
    type: 'item',
    icon: 'material-outline:adjust',
    url: 'goals',
    end: true,
    auth: AuthRoles.UserManagement,
  },
  {
    id: 'users-component',
    title: 'Users',
    translate: 'Users',
    type: 'item',
    icon: 'material-outline:group',
    url: 'users',
    end: true,
    auth: AuthRoles.UserManagement,
  },
  {
    id: 'tickets-component',
    title: 'Tickets',
    translate: 'Tickets',
    type: 'item',
    icon: 'material-outline:confirmation_number',
    url: 'tickets',
    auth: AuthRoles.Tickets,
  },
  {
    id: 'payors-component',
    title: 'Payors',
    translate: 'Payors',
    type: 'item',
    icon: 'material-outline:attach_money',
    url: 'payors',
    end: true,
    auth: AuthRoles.Payments,
  },
  {
    id: 'deposits-component',
    title: 'Deposits',
    translate: 'Deposits',
    type: 'item',
    icon: 'material-outline:savings',
    url: 'deposits',
    end: true,
    auth: AuthRoles.Payments,
  },
  {
    id: 'payments-component',
    title: 'Payments',
    translate: 'Payments',
    type: 'item',
    icon: 'material-outline:payment',
    url: 'payments',
    end: true,
    auth: AuthRoles.Payments,
  },
  {
    id: 'sales-reports-component',
    title: 'Sales\xa0Reports',
    translate: 'Sales\xa0Reports',
    type: 'item',
    icon: 'material-outline:bar_chart',
    url: 'sales-reports',
    end: true,
    auth: AuthRoles.Reporting,
  },
  {
    id: 'sales-closed-report',
    title: 'Sales\xa0Closed\xa0Report',
    translate: 'Sales\xa0Closed\xa0Report',
    type: 'item',
    icon: 'material-outline:trending_down',
    url: 'sales-closed-report',
    end: true,
    auth: AuthRoles.Reporting,
  },
  {
    id: 'cancellation-reasons-component',
    title: 'Cancellation\xa0Reasons',
    translate: 'Cancellation\xa0Reasons',
    type: 'item',
    icon: 'material-outline:cancel',
    url: 'cancellation-reasons',
    end: true,
    auth: AuthRoles.LicenseeAdmin,
  },
  {
    id: 'company-summary-component',
    title: 'Company\xa0Summary',
    translate: 'Company\xa0Summary',
    type: 'item',
    icon: 'material-outline:bar_chart',
    url: 'company-summary',
    end: true,
    auth: AuthRoles.CompanySummary,
  },
  {
    id: 'company-services-summary-component',
    title: 'Services',
    translate: 'Services',
    type: 'item',
    icon: 'material-outline:miscellaneous_services',
    url: 'company-services-summary',
    end: true,
    auth: AuthRoles.CompanySummary,
  },
  {
    id: 'testimonials-component',
    title: 'Testimonials',
    translate: 'Testimonials',
    type: 'item',
    icon: 'material-outline:star',
    url: 'testimonials',
    end: true,
    auth: AuthRoles.Testimonials,
  },
];

export default navigationConfig;
